<template>
    <intelligence-shell
        :title="$t('pages.intelligence.delivery.title')"
        :subtitle="$t('pages.intelligence.delivery.subtitle')"
        @filters-change="onFiltersChange"
    >
        <div v-if="isLoading" class="intelligence-state">
            <common-loader :isProcessing="true"></common-loader>
            <span>{{ $t('pages.intelligence.delivery.loading') }}</span>
        </div>

        <div v-else-if="hasError" class="intelligence-state intelligence-state--error">
            {{ $t('pages.intelligence.delivery.error') }}
        </div>

        <template v-else-if="delivery">
            <intelligence-delivery-kpi-cards :kpis="delivery.kpis"></intelligence-delivery-kpi-cards>

            <div class="intelligence-charts">
                <intelligence-delivery-chart :channels="delivery.channels"></intelligence-delivery-chart>
                <intelligence-delivery-table :channels="delivery.channels"></intelligence-delivery-table>
            </div>
        </template>
    </intelligence-shell>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import IntelligenceShell from 'components/page-elements/intelligence/IntelligenceShell'
    import IntelligenceDeliveryKpiCards from 'components/page-elements/intelligence/IntelligenceDeliveryKpiCards'
    import IntelligenceDeliveryChart from 'components/page-elements/intelligence/IntelligenceDeliveryChart'
    import IntelligenceDeliveryTable from 'components/page-elements/intelligence/IntelligenceDeliveryTable'
    import IntelligenceAPI from 'api/IntelligenceAPI'

    export default {
        mixins: [PageWithTitleMixin],

        components: {
            IntelligenceShell,
            IntelligenceDeliveryKpiCards,
            IntelligenceDeliveryChart,
            IntelligenceDeliveryTable,
        },

        data() {
            return {
                isLoading: false,
                hasError: false,
                delivery: null,
                filters: null,
            }
        },

        computed: {
            pageTitle() {
                return this.$t('pages.intelligence.delivery.title')
            },
        },

        methods: {
            onFiltersChange(filters) {
                this.filters = filters
                this.loadDelivery()
            },

            loadDelivery() {
                if (!this.filters || !this.filters.fromDate || !this.filters.toDate) return

                this.isLoading = true
                this.hasError = false

                IntelligenceAPI.getDelivery(this.filters)
                    .then((response) => {
                        this.delivery = response
                    })
                    .catch(() => {
                        this.hasError = true
                        this.delivery = null
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },
        },
    }
</script>

<style lang="scss" scoped>
    .intelligence-charts {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 24px;
    }

    .intelligence-state {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 32px;
        color: #6b7280;
        font-size: 14px;

        &--error {
            color: #b91c1c;
        }
    }

    @media (max-width: 1100px) {
        .intelligence-charts {
            grid-template-columns: 1fr;
        }
    }
</style>
